import { PaxCheckApplyManualDocumentResult } from "api";
import PaxSession, { PaxSessionFromApi } from "models/session/pax-session";

interface SubmitManualDocumentResponse {
  updatedPaxSession?: PaxSession;
  successfullyVerified: boolean;
}

export function ApplyManualDocumentResponseFromApi(
  res: PaxCheckApplyManualDocumentResult
): SubmitManualDocumentResponse {
  return {
    successfullyVerified: res.successfullyVerified,
    updatedPaxSession: res.updatedPaxSession
      ? PaxSessionFromApi(res.updatedPaxSession)
      : undefined,
  };
}

export default SubmitManualDocumentResponse;
